exports.stop_words = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'aca',
    'actualmente',
    'acuerdo',
    'adelante',
    'ademas',
    'adrede',
    'afirmo',
    'agrego',
    'ahi',
    'ahora',
    'ajena',
    'ajenas',
    'ajeno',
    'ajenos',
    'al',
    'algo',
    'algun',
    'alguna',
    'algunas',
    'alguno',
    'algunos',
    'alla',
    'alli',
    'alrededor',
    'ambos',
    'ampleamos',
    'anadio',
    'antano',
    'ante',
    'anterior',
    'antes',
    'apenas',
    'aproximadamente',
    'aquel',
    'aquella',
    'aquellas',
    'aquello',
    'aquellos',
    'aqui',
    'arriba',
    'arribaabajo',
    'aseguro',
    'asi',
    'atras',
    'aun',
    'aunque',
    'ayer',
    'b',
    'bajo',
    'bastante',
    'bien',
    'breve',
    'buen',
    'buena',
    'buenas',
    'bueno',
    'buenos',
    'c',
    'cabe',
    'cada',
    'casi',
    'cerca',
    'cierta',
    'ciertas',
    'cierto',
    'ciertos',
    'cinco',
    'claro',
    'comento',
    'como',
    'con',
    'conmigo',
    'conocer',
    'conseguimos',
    'conseguir',
    'considera',
    'considero',
    'consigo',
    'consigue',
    'consiguen',
    'consigues',
    'contigo',
    'contra',
    'cosas',
    'creo',
    'cual',
    'cuales',
    'cualquier',
    'cualquiera',
    'cualquieras',
    'cuan',
    'cuando',
    'cuanta',
    'cuantas',
    'cuanto',
    'cuantos',
    'cuatro',
    'cuenta',
    'd',
    'da',
    'dado',
    'dan',
    'dar',
    'de',
    'debajo',
    'debe',
    'deben',
    'debido',
    'decir',
    'dejar',
    'dejo',
    'del',
    'delante',
    'demas',
    'demasiada',
    'demasiadas',
    'demasiado',
    'demasiados',
    'dentro',
    'deprisa',
    'desde',
    'despacio',
    'despues',
    'detras',
    'dia',
    'dias',
    'dice',
    'dicen',
    'dicho',
    'dieron',
    'diferente',
    'diferentes',
    'dijeron',
    'dijo',
    'dio',
    'disponer',
    'disponga',
    'dispongais',
    'dispongamos',
    'dispongas',
    'dispongo',
    'donde',
    'dos',
    'durante',
    'e',
    'ejemplo',
    'el',
    'ella',
    'ellas',
    'ello',
    'ellos',
    'embargo',
    'empleais',
    'emplean',
    'emplear',
    'empleas',
    'empleo',
    'en',
    'encima',
    'encuentra',
    'enfrente',
    'enseguida',
    'entonces',
    'entre',
    'era',
    'erais',
    'eramos',
    'eran',
    'eras',
    'eres',
    'es',
    'esa',
    'esas',
    'ese',
    'eses',
    'eso',
    'esos',
    'esta',
    'estaba',
    'estabais',
    'estabamos',
    'estaban',
    'estabas',
    'estad',
    'estada',
    'estadas',
    'estado',
    'estados',
    'estais',
    'estamos',
    'estan',
    'estando',
    'estar',
    'estara',
    'estaran',
    'estaras',
    'estare',
    'estareis',
    'estaremos',
    'estaria',
    'estariais',
    'estariamos',
    'estarian',
    'estarias',
    'estas',
    'este',
    'esteis',
    'estemos',
    'esten',
    'estes',
    'esto',
    'estos',
    'estoy',
    'estuve',
    'estuviera',
    'estuvierais',
    'estuvieramos',
    'estuvieran',
    'estuvieras',
    'estuvieron',
    'estuviese',
    'estuvieseis',
    'estuviesemos',
    'estuviesen',
    'estuvieses',
    'estuvimos',
    'estuviste',
    'estuvisteis',
    'estuvo',
    'etc',
    'ex',
    'excepto',
    'existe',
    'existen',
    'explico',
    'expreso',
    'f',
    'fin',
    'final',
    'fue',
    'fuera',
    'fuerais',
    'fueramos',
    'fueran',
    'fueras',
    'fueron',
    'fuese',
    'fueseis',
    'fuesemos',
    'fuesen',
    'fueses',
    'fui',
    'fuimos',
    'fuiste',
    'fuisteis',
    'g',
    'general',
    'gran',
    'grandes',
    'gueno',
    'h',
    'ha',
    'habeis',
    'haber',
    'habia',
    'habiais',
    'habiamos',
    'habian',
    'habias',
    'habida',
    'habidas',
    'habido',
    'habidos',
    'habiendo',
    'habla',
    'hablan',
    'habra',
    'habran',
    'habras',
    'habre',
    'habreis',
    'habremos',
    'habria',
    'habriais',
    'habriamos',
    'habrian',
    'habrias',
    'hace',
    'haceis',
    'hacemos',
    'hacen',
    'hacer',
    'hacerlo',
    'haces',
    'hacia',
    'haciendo',
    'hago',
    'han',
    'has',
    'hasta',
    'hay',
    'haya',
    'hayais',
    'hayamos',
    'hayan',
    'hayas',
    'he',
    'hecho',
    'hemos',
    'hicieron',
    'hizo',
    'horas',
    'hoy',
    'hube',
    'hubiera',
    'hubierais',
    'hubieramos',
    'hubieran',
    'hubieras',
    'hubieron',
    'hubiese',
    'hubieseis',
    'hubiesemos',
    'hubiesen',
    'hubieses',
    'hubimos',
    'hubiste',
    'hubisteis',
    'hubo',
    'i',
    'igual',
    'incluso',
    'indico',
    'informo',
    'intenta',
    'intentais',
    'intentamos',
    'intentan',
    'intentar',
    'intentas',
    'intento',
    'ir',
    'j',
    'jamas',
    'junto',
    'juntos',
    'k',
    'l',
    'la',
    'lado',
    'largo',
    'las',
    'le',
    'lejos',
    'les',
    'llego',
    'lleva',
    'llevar',
    'lo',
    'los',
    'luego',
    'lugar',
    'm',
    'mal',
    'manera',
    'manifesto',
    'mas',
    'mayor',
    'me',
    'mediante',
    'medio',
    'mejor',
    'menciono',
    'menos',
    'menudo',
    'mi',
    'mia',
    'mias',
    'mientras',
    'mio',
    'mios',
    'mis',
    'misma',
    'mismas',
    'mismo',
    'mismos',
    'modo',
    'momento',
    'mucha',
    'muchas',
    'muchisima',
    'muchisimas',
    'muchisimo',
    'muchisimos',
    'mucho',
    'muchos',
    'muy',
    'n',
    'nada',
    'nadie',
    'ni',
    'ningun',
    'ninguna',
    'ningunas',
    'ninguno',
    'ningunos',
    'no',
    'nos',
    'nosotras',
    'nosotros',
    'nuestra',
    'nuestras',
    'nuestro',
    'nuestros',
    'nueva',
    'nuevas',
    'nuevo',
    'nuevos',
    'nunca',
    'o',
    'ocho',
    'os',
    'otra',
    'otras',
    'otro',
    'otros',
    'p',
    'pais',
    'para',
    'parece',
    'parecer',
    'parte',
    'partir',
    'pasada',
    'pasado',
    'peor',
    'pero',
    'pesar',
    'poca',
    'pocas',
    'poco',
    'pocos',
    'podeis',
    'podemos',
    'poder',
    'podra',
    'podran',
    'podria',
    'podriais',
    'podriamos',
    'podrian',
    'podrias',
    'poner',
    'por',
    'por que',
    'porque',
    'posible',
    'primer',
    'primera',
    'primeras',
    'primero',
    'primero desde',
    'primeros',
    'principalmente',
    'pronto',
    'propia',
    'propias',
    'propio',
    'propios',
    'proximo',
    'proximos',
    'pudo',
    'pueda',
    'puede',
    'pueden',
    'puedo',
    'pues',
    'q',
    'qeu',
    'que',
    'quedo',
    'queremos',
    'querer',
    'quien',
    'quienes',
    'quienesquiera',
    'quienquiera',
    'quiere',
    'quiza',
    'quizas',
    'r',
    'raras',
    'realizado',
    'realizar',
    'realizo',
    'repente',
    'respecto',
    's',
    'sabe',
    'sabeis',
    'sabemos',
    'saben',
    'saber',
    'sabes',
    'sal',
    'salvo',
    'se',
    'sea',
    'seais',
    'seamos',
    'sean',
    'seas',
    'segun',
    'segunda',
    'segundo',
    'seis',
    'senalo',
    'ser',
    'sera',
    'seran',
    'seras',
    'sere',
    'sereis',
    'seremos',
    'seria',
    'seriais',
    'seriamos',
    'serian',
    'serias',
    'si',
    'sido',
    'siempre',
    'siendo',
    'siete',
    'sigue',
    'siguiente',
    'sin',
    'sino',
    'so',
    'sobre',
    'sois',
    'sola',
    'solamente',
    'solas',
    'solo',
    'solos',
    'somos',
    'son',
    'soy',
    'soyos',
    'sr',
    'sra',
    'sres',
    'sta',
    'su',
    'supuesto',
    'sus',
    'suya',
    'suyas',
    'suyo',
    'suyos',
    't',
    'tal',
    'tales',
    'tambien',
    'tampoco',
    'tan',
    'tanta',
    'tantas',
    'tanto',
    'tantos',
    'tarde',
    'te',
    'temprano',
    'tendra',
    'tendran',
    'tendras',
    'tendre',
    'tendreis',
    'tendremos',
    'tendria',
    'tendriais',
    'tendriamos',
    'tendrian',
    'tendrias',
    'tened',
    'teneis',
    'tenemos',
    'tener',
    'tenga',
    'tengais',
    'tengamos',
    'tengan',
    'tengas',
    'tengo',
    'tenia',
    'teniais',
    'teniamos',
    'tenian',
    'tenias',
    'tenida',
    'tenidas',
    'tenido',
    'tenidos',
    'teniendo',
    'tercera',
    'ti',
    'tiempo',
    'tiene',
    'tienen',
    'tienes',
    'toda',
    'todas',
    'todavia',
    'todo',
    'todos',
    'tomar',
    'total',
    'trabaja',
    'trabajais',
    'trabajamos',
    'trabajan',
    'trabajar',
    'trabajas',
    'trabajo',
    'tras',
    'trata',
    'traves',
    'tres',
    'tu',
    'tus',
    'tuve',
    'tuviera',
    'tuvierais',
    'tuvieramos',
    'tuvieran',
    'tuvieras',
    'tuvieron',
    'tuviese',
    'tuvieseis',
    'tuviesemos',
    'tuviesen',
    'tuvieses',
    'tuvimos',
    'tuviste',
    'tuvisteis',
    'tuvo',
    'tuya',
    'tuyas',
    'tuyo',
    'tuyos',
    'u',
    'ultima',
    'ultimas',
    'ultimo',
    'ultimos',
    'un',
    'una',
    'unas',
    'uno',
    'unos',
    'uns',
    'usa',
    'usais',
    'usamos',
    'usan',
    'usar',
    'usas',
    'uso',
    'usted',
    'ustedes',
    'v',
    'va',
    'vais',
    'valor',
    'vamos',
    'van',
    'varias',
    'varios',
    'vaya',
    'veces',
    'ver',
    'verdad',
    'verdadera',
    'verdadero',
    'vez',
    'vosotras',
    'vosotros',
    'voy',
    'vuestra',
    'vuestras',
    'vuestro',
    'vuestros',
    'w',
    'x',
    'y',
    'ya',
    'yo',
    'z'
];
